import {useCallback} from 'react';
import {useAdjustDraftStore} from '@/store/audit';
import {resolveInventoriesToPaperCode} from '@/adjustment/adjust/utils/companion-codes';

type HandleFsSelectionParams = {
  /** Kept for call-site compatibility; WP→FS removed — always WP→WP. */
  selectedAdjustmentMode?: number | null;
  /** Kept for call-site compatibility; unused after WP→FS removal. */
  mergeData?: () => any;
  showSnackbar: (message: string, severity: 'success' | 'error' | 'warning') => void;
  companyId: number;
  annualId: number;
  setFsDrawerOpen: (open: boolean) => void;
  setToPaperSelected: (selected: boolean) => void;
  onClose: () => void;
};

/**
 * FS selection handler for working-paper adjustment (WP→WP only).
 */
export function useHandleFsSelection({
  showSnackbar,
  setFsDrawerOpen,
  setToPaperSelected,
}: HandleFsSelectionParams) {
  const adjustDraftStore = useAdjustDraftStore();

  return useCallback(async (args: { code: string; node: any; payload?: Record<string, any>; wpFetchCode?: string }) => {
    // WP→WP：PL-COT-OI/CI → BS-CA-INV（Drawer 已归一时为幂等）
    const toCode = resolveInventoriesToPaperCode(args.code) || args.code;
    const wpFetchCode = String(args.wpFetchCode || args.payload?.wpFetchCode || '').trim();
    adjustDraftStore.setToPaper(
      toCode,
      undefined,
      wpFetchCode ? {wpFetchCodes: {[toCode]: wpFetchCode}} : undefined,
    );
    setToPaperSelected(true);
    setFsDrawerOpen(false);
    showSnackbar(`Selected target code: ${toCode}`, 'success');
  }, [
    showSnackbar,
    adjustDraftStore,
    setFsDrawerOpen,
    setToPaperSelected,
  ]);
}
